import { Field as ArkField } from "@ark-ui/react";
import { PropsWithChildren, ReactNode } from "react";
import { Text } from "../typography/Text";
import { HStack, Stack } from "@zenchef/styled-system/jsx";
import Icon from "../Icon/Icon";
import Tooltip from "../Tooltip/Tooltip";

export interface FieldLabelProps extends PropsWithChildren {
  description?: ReactNode;
  tooltip?: string;
  tooltipZindex?: number;
  as?: React.ForwardRefExoticComponent<{ children: React.ReactNode }>;
}

export const FieldLabel = ({
  children,
  description,
  tooltip,
  tooltipZindex = 1010,
  as = ArkField.Label,
}: FieldLabelProps) => {
  const Label = as;

  return (
    <Stack gap="gap.0" marginBottom="padding.1">
      <Label>
        <HStack gap="gap.1">
          <Text textStyle="title.s">{children}</Text>
          {tooltip ? (
            <Tooltip title={tooltip} zIndex={tooltipZindex}>
              <Icon name="info-circle" fontSize="100" />
            </Tooltip>
          ) : null}
        </HStack>
      </Label>
      {description ? (
        <Text
          textStyle="paragraph.m.regular"
          color="content.neutral.base.subtle"
          data-part="description"
        >
          {description}
        </Text>
      ) : null}
    </Stack>
  );
};
